import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import MoonLoader from "react-spinners/MoonLoader";
import { COLORS } from "../../config";
import FieldWithEdit from "../../components/FieldItems/FieldWithEdit";
import useAppointments from "../../store/appointments/appointmentsContext";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import RedButton from "../../components/Buttons/RedButton";
import useScript from "../../hooks/useScript";

function ViewAppointmentDetails({ appointmentId: id, appointment: appointmentDetails }) {
  const { getAppointmentDetails } = useAppointments();
  const history = useHistory();

  const [isLoading, setIsLoading] = React.useState(true);
  const [appointment, setAppointment] = React.useState({});
  const [inviteeDetails, setInviteeDetails] = React.useState({});

  useScript("https://assets.calendly.com/assets/external/widget.js");

  useEffect(() => {
    fetchDetails();
  }, [id]);

  useEffect(() => {
    window.addEventListener("click", (event) => {
      if (event.target.className === "calendly-popup-close") {
        fetchDetails();
      }
    });
  });

  async function fetchDetails() {
    if (id) {
      await getAppointmentDetails(id)
        .then((res) => {
          setAppointment(res.resource);
          setInviteeDetails(res.invitee);
          setIsLoading(false);
        })
        .catch((err) => {
          history.goBack();
        });
    }
  }

  if (isLoading)
    return (
      <div className="flex justify-around items-center h-full">
        <MoonLoader color={COLORS.colorPrimary} />
      </div>
    );

  const handleAppointmentClick = (url) => {
    window.Calendly.initPopupWidget({
      url: url,
    });
    return false;
  };

  return (
    <div className="flex flex-col">
      <div className="bg-white rounded shadow py-12 px-10">
        <div className="flex justify-between items-center">
          <h1 className="mb-10 text-2xl text-secondary">Details</h1>
        </div>
        <div className="grid grid-cols-1 gap-y-4">
          <FieldWithEdit locked label="Name" data={appointment.name} />
          <FieldWithEdit
            locked
            label="Start Date"
            data={new Date(appointment.start_time).toString()}
          />
          <FieldWithEdit
            locked
            label="End Date"
            data={new Date(appointment.end_time).toString()}
          />
          <FieldWithEdit locked label="Status" data={appointment.status} />
          <FieldWithEdit
            locked
            label="Location"
            data={appointment.location.location}
          />
        </div>
      </div>
      <div className="w-full flex flex-row-reverse pb-4">
        <PrimaryButton
          className="ml-5 mt-8"
          text="Back"
          onClick={() => history.goBack()}
        />
        {appointment.status == "active" && (
          <RedButton
            className="mt-8"
            text={"Cancel Appointment"}
            onClick={() => handleAppointmentClick(inviteeDetails.cancel_url)}
          />
        )}
      </div>
    </div>
  );
}

export default ViewAppointmentDetails;
